<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">Юридические лица</h2>
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="(tab, i) in tabs" :name="tab.key" :label="tab.name" :key="i">
          <component :is="tab.component" />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import OrgsList from "@/components/Orgs/tabs/OrgsList";

export default {
  name: "Orgs",
  data() {
    return {
      activeTab: "list",
      tabs: [
        {
          name: "Список",
          key: "list",
          component: OrgsList,
        },
      ],
    };
  },
};
</script>
